export default __webpack_public_path__ + "static/give-back-mob-b4de522ba576b98d17abca8649a99a2a.jpg";